import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.js-item-card-hero-slider');

    sliders.forEach(slider => {
        const sliderItem = slider.querySelectorAll('.swiper-slide');

        if (sliderItem.length <= 1) {
            slider.classList.add('is-hidden-nav');
            return;
        }

        const navArrowPrev = slider.querySelector('.js-swiper-nav-prev');
        const navArrowNext = slider.querySelector('.js-swiper-nav-next');
        const navPagination = slider.querySelector('.js-swiper-pagination');

        const swiper = new Swiper(slider, {
            modules: [Navigation, Pagination, EffectFade],
            spaceBetween: 0,
            slidesPerView: 1,

            watchOverflow: true,
            speed: 1000,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
                // // false - Включает плавное затухание слайдов
                // // Обратите внимание, что crossFadeследует установить значение true,
                // // чтобы не видеть содержимое позади или под ним.
            },

            navigation: {
                prevEl: navArrowPrev,
                nextEl: navArrowNext,
            },
            pagination: {
                el: navPagination,
                clickable: true,
            },
        });

    });

});


